var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleAuthoritiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    stroke: "#322F61",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#322F61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3770_26789)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3770_26789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7222 17.7778V25.7778H26.2778V30.2222H18.2778V17.7778H30.7222ZM30.7222 16H18.2778C17.3 16 16.5 16.8 16.5 17.7778V30.2222C16.5 31.2 17.3 32 18.2778 32H27.1667L32.5 26.6667V17.7778C32.5 16.8 31.7 16 30.7222 16ZM24.5 25.7778H20.0556V24H24.5V25.7778ZM28.9444 22.2222H20.0556V20.4444H28.9444V22.2222Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3770_26789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3770_26789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleAuthoritiesIcon);
export default __webpack_public_path__ + "static/media/role-authorities-icon.4598504f623a70d18ac6fc68fc86904a.svg";
export { ForwardRef as ReactComponent };